import {
  StepperSelectionEvent,
  STEPPER_GLOBAL_OPTIONS,
} from '@angular/cdk/stepper';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { SubscriptionManager } from 'src/app/_helpers/subscription-manager';
import { CurrencyState } from 'src/app/_models/state/optionUIState';
import { SubscriptionLevel } from '../../models/user';
import { TidService } from '../../services/tid.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class SignUpComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('stepper') private myStepper: MatStepper;
  signUpForm: FormGroup;
  showForm: boolean;
  isStepperVisible = true;
  private sm = new SubscriptionManager();
  displayCurrency: CurrencyState = {
    display: 'US Dollars',
    value: 0,
    exchangeRate: 1.051,
    symbol: '$',
    isPrefix: true,
  };

  constructor(
    private formBuilder: FormBuilder,
    private tidService: TidService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.landing) {
        this.tidService.email = '';
        this.showForm = true;
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: {
            featureLevel: params.featureLevel,
          },
        });
      }
    });
  }

  ngOnInit(): void {
    this.signUpForm = this.formBuilder.group({
      featureLevel: '',
    });
  }
  get signUpControls(): { [key: string]: AbstractControl } {
    return this.signUpForm.controls;
  }

  ngAfterViewInit() {
    if (this.tidService.email) {
      this.showForm = true;
      this.tidService.errorMessage.next(null);
      this.myStepper.steps.first.completed = true;
      this.myStepper.steps.first.interacted = true;
      this.myStepper.next();
      this.myStepper.selected.completed = true;
      this.changeDetectorRef.detectChanges();
    }
  }

  showForms(event: SubscriptionLevel) {
    this.tidService.email = '';
    this.showForm = true;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        featureLevel: event,
      },
    });
  }
  navigateFeaturePage() {
    this.isStepperVisible = true;
    this.changeDetectorRef.detectChanges();
    this.myStepper.steps.first.completed = false;
    this.myStepper.steps.first.editable = true;
    this.myStepper.selectedIndex = 0;
    this.showForm = false;
    this.myStepper.reset();
  }
  nextStep(event: boolean) {
    this.myStepper.selected.completed = event;
  }
  setIndex(event: StepperSelectionEvent) {
    setTimeout(() => {
      this.myStepper.selectedIndex = event.selectedIndex;
    }, 0);
  }

  submit() {
    this.isStepperVisible = false;
    this.sm.manage = this.tidService.loginWithTid().subscribe();
  }
  redirectToLogin() {
    this.tidService.accounts$.next([]);
  }
  ngOnDestroy(): void {
    this.tidService.email = '';
    this.tidService.errorMessage.next(null);
  }
}
